import styled from 'styled-components';

export const Frame = styled.div`
  border-radius: 50%;
  background-color: #ececec;
  padding: 30px;
  margin-bottom: 20px;
`;
